var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgK1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.4,
    height: 38.463,
    viewBox: "146.105 2164.649 40.4 38.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36785"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "bill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.213 2164.65c-4.027 0-7.463 2.627-8.75 6.145h-16.246c-.36 0-.652.324-.654.684l-.155 22.961h-4.63c-.362 0-.673.262-.673.624v2.914a5.142 5.142 0 0 0 4.91 5.12v.015h20.208v-.02c.164.007.231.02.335.02h.014a5.141 5.141 0 0 0 5.133-5.141v-14.733c.164.01.337.014.506.014 5.124 0 9.294-4.178 9.294-9.302s-4.168-9.302-9.292-9.302Zm-25.95 37.154h-.004a3.85 3.85 0 0 1-3.844-3.833v-2.222h18.981v2.213a5.135 5.135 0 0 0 1.516 3.638c.068.069.154.122.226.204h-16.875Zm24.133-3.833a3.832 3.832 0 0 1-3.825 3.833h-.012a3.86 3.86 0 0 1-3.854-3.842v-2.898a.604.604 0 0 0-.625-.624h-14.363l.15-22.336H168.1a9.835 9.835 0 0 0-.18 1.818 9.23 9.23 0 0 0 .791 3.746h-6.182a.654.654 0 1 0 0 1.309h6.892a9.237 9.237 0 0 0 5.976 4.099v14.895Zm1.817-16.027a7.984 7.984 0 1 1 7.984-7.984 7.993 7.993 0 0 1-7.984 7.984Zm0 0",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.326 2182.024c-1.155 0-2.095.91-2.095 2.028 0 1.119.94 2.029 2.095 2.029 1.156 0 2.096-.91 2.096-2.029 0-1.118-.94-2.028-2.096-2.028Zm0 2.748c-.433 0-.786-.323-.786-.72 0-.397.353-.72.786-.72.434 0 .786.324.786.72 0 .397-.352.72-.786.72Zm0 0",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.873 2184.05c0 .36.293.654.655.654h8.726a.655.655 0 0 0 0-1.31h-8.726a.654.654 0 0 0-.655.655Zm0 0",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.326 2176.334c-1.155 0-2.095.91-2.095 2.029 0 1.118.94 2.028 2.095 2.028 1.156 0 2.096-.91 2.096-2.028 0-1.119-.94-2.03-2.096-2.03Zm0 2.748c-.433 0-.786-.323-.786-.72 0-.396.353-.719.786-.719.434 0 .786.323.786.72 0 .396-.352.72-.786.72Zm0 0",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.326 2187.713c-1.155 0-2.095.91-2.095 2.028 0 1.119.94 2.029 2.095 2.029 1.156 0 2.096-.91 2.096-2.029 0-1.118-.94-2.028-2.096-2.028Zm0 2.748c-.433 0-.786-.323-.786-.72 0-.396.353-.72.786-.72.434 0 .786.324.786.72 0 .397-.352.72-.786.72Zm0 0",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.254 2189.122h-8.726a.654.654 0 1 0 0 1.31h8.726a.655.655 0 0 0 0-1.31Zm0 0",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2342"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "rupee (10)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.554 2178.366c-.15 0-.25-.05-.35-.15l-3-3c-.15-.15-.2-.35-.1-.55.05-.2.25-.3.45-.3h1.5c.4 0 .8-.15 1.05-.45.3-.25.45-.65.45-1.05s-.15-.8-.45-1.05c-.25-.3-.65-.45-1.05-.45h-1.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.5c.3 0 .5.2.5.5s-.2.5-.5.5h-2c.3.45.5.95.5 1.5 0 .65-.25 1.3-.75 1.75-.45.5-1.1.75-1.75.75h-.3l2.15 2.15c.2.2.2.5 0 .7-.1.1-.2.15-.35.15Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2406"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.054 2173.366h-5.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.5c.3 0 .5.2.5.5s-.2.5-.5.5Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2407"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK1);
export default __webpack_public_path__ + "static/media/k1.37ece14d2e1259ddf74c318b864ee37c.svg";
export { ForwardRef as ReactComponent };